export default __webpack_public_path__ + "static/media/쉐어플러그_03.400dc2ba.svg";